module.exports = __webpack_public_path__ + "img/IMG20190716094112.5f143327.jpg";